var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-popup",style:(`display: ${_vm.settings.display};top: ${_vm.settings.top}px; left: ${
      _vm.settings.left
    }px`)},[_c('ul',{staticClass:"mt-popup__list"},_vm._l((_vm.settings.values),function(item){return _c('li',{key:item.key,staticClass:"mt-popup__item"},[_c('div',{staticClass:"mt-popup__key"},[_vm._v(" "+_vm._s(item.key)+" ")]),_c('div',{staticClass:"mt-popup__value"},[_vm._v(" "+_vm._s(_vm.getValue(item.value))+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }